import * as React from 'react';
import { Modal } from './modal';
import { EventLocation } from '../../Model/core';
import { payload } from './main';

export interface BookButtonProps {
    title: string;
}

export function BookButton({ title }: BookButtonProps) {
    const [clicked, setClicked] = React.useState(false);

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();

        if (payload.Locations.length == 1) {
            window.location.href = payload.Locations[0].Link
        } else {
            setClicked(!clicked);
        }
    };

    return (
        <>
            <button className='cm-book-button' title={title} onClick={handleClick}>{title}</button>

            <Modal visible={clicked}>
                <div className='cm-book-container'>
                    <h4>{payload.EventLocationPopupText}</h4>

                    <div className='cm-book-selection'>
                        {payload.Locations.map(l => <Location key={l.PageId} location={l} />)}
                    </div>

                    <div className='cm-book-close' onClick={handleClick} title='Stäng' tabIndex={-1}>
                        <img src='/images/cancel-32.png' />
                    </div>
                </div>
            </Modal>
        </>
    );
}

function Location({ location }: { location: EventLocation }) {
    return (
        <a className='cm-book-button' href={location.Link} title={location.Title}>{location.Title}</a>
    );
}